export const order = [
  "1. a. Полное название автоматизированной системы (АС)".toLocaleLowerCase(),
  "b. Краткое название АС".toLocaleLowerCase(),
  "c. Номер АС в Реестре АС".toLocaleLowerCase(),
  "2. Полные наименования автоматизируемых процессов с указанием их кодов".toLocaleLowerCase(),
  "3. Наименования этапов процессов с указанием их кодов".toLocaleLowerCase(),
  "4. (A). Тип автоматизируемого банковского технологического процесса (ТП)".toLocaleLowerCase(),
  "5. Назначение АС, перечень выполняемых ею функций".toLocaleLowerCase(),
  "Если какие-либо функции АС касаются работы с банковскими картами, то явно указать к какой области это относится".toLocaleLowerCase(),
  "6. Заказчик АС".toLocaleLowerCase(),
  "7. Владелец АС".toLocaleLowerCase(),
  "8. (B). Категории обрабатываемой в АС информации".toLocaleLowerCase(),
  "(B3) Информация категории «Банковская тайна» (БТ) (платежная информация), в том числе".toLocaleLowerCase(),
  "(PCD) БТ.1.7. Информация, нанесенная на банковские карты".toLocaleLowerCase(),
  "(B5) Персональные данные, если их состав превышает минимальный (в АС обрабатываются какие-либо ПДн кроме Ф.И.О. и/или логин учетной записи и/или e-mail в домене @gazprombank.ru работников Банка)".toLocaleLowerCase(),
  "Сущности обрабатываемых ПДн".toLocaleLowerCase(),
  "Категории субъектов ПДн, чьи ПДн обрабатываются".toLocaleLowerCase(),
  "Планируемый объем субъектов ПДн, учитываемых в АС".toLocaleLowerCase(),
  "Планируется ли трансграничная передача ПДн".toLocaleLowerCase(),
  "При обработке ПДн VIP-клиентов, указать их категории".toLocaleLowerCase(),
  "В АС планируется взаимодействие со следующими АС".toLocaleLowerCase(),
  "Получение данных из АС".toLocaleLowerCase(),
  "Получатели информации из АС".toLocaleLowerCase(),
  "10. (E). Требуемые каналы доступа к АС".toLocaleLowerCase(),
  "a. (EA) Из внутренней сети Банка".toLocaleLowerCase(),
  "b. (EC) Через Мобильный офис/АС ПКМ".toLocaleLowerCase(),
  "c. (ED) Через общедоступные сети (Интернет)".toLocaleLowerCase(),
  "11. Предполагаемое количество пользователей АС".toLocaleLowerCase(),
  "Предполагаемое количество групп/ролей в АС".toLocaleLowerCase(),
  "12. (F). Автоматизация предоставления доступа к АС".toLocaleLowerCase(),
  "13. (N). В АС для аутентификации пользователей (сотрудников Банка) планируется использование".toLocaleLowerCase(),
  "14. (H). Планируется ли применение сертифицированных ФСБ России средств криптографической защиты информации (СКЗИ)?".toLocaleLowerCase(),
  "15. (I). Способ создания продукта".toLocaleLowerCase(),
  "16. В составе АС используется мобильное приложение, разработанное по заказу Банка или самостоятельно подразделениями Банка".toLocaleLowerCase(),
  "17. В АС планируется использование средств контейнерной виртуализации".toLocaleLowerCase(),
  "18. (L). В АС планируется генерация и/или использование одноразовых кодов (СМС, Push, …)".toLocaleLowerCase(),
  "19. Архитектура АС (возможные виды клиентов)".toLocaleLowerCase(),
  "20. В АС планируется обработка ПДн граждан Евросоюза".toLocaleLowerCase(),
  "21. (J). Дополнительные условия/ограничения/требования Заказчика АС к проектируемой АС".toLocaleLowerCase(),
  "Руководитель ССП ИТ-блока, выполняющего работы по созданию (модернизации) АС".toLocaleLowerCase()
];

export const sortCallBack = (a, b) => {
  const aIndex = order.indexOf(a.name?.toLocaleLowerCase());
  const bIndex = order.indexOf(b.name?.toLocaleLowerCase());

  if (aIndex === -1 && bIndex === -1) {
    return 0;
  } else if (aIndex === -1) {
    return 1;
  } else if (bIndex === -1) {
    return -1;
  } else {
    return aIndex - bIndex;
  }
}
